import { render, staticRenderFns } from "./SuppliersVerification.vue?vue&type=template&id=40198858&"
import script from "./SuppliersVerification.vue?vue&type=script&lang=js&"
export * from "./SuppliersVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports